import React, { useState } from "react";
import { Dialog, DialogBody, DialogContent, DialogSurface, DialogTitle } from "@fluentui/react-components";
import { AddCircle24Filled } from "@fluentui/react-icons";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { RawMaterial } from "../redux/powderOrder";
import PowderPieChart from "./PowderPieChart";
const formatNumber = (value: number | null): string => {
    if (value === null || Number.isNaN(value)) return "-";
    return value.toFixed(4).replace(/\.?0+$/, "").replace(".", ",");
};

const hasChemicalComposition = (material: RawMaterial) => Boolean(material.powderComposition?.length);

interface PowderRawMaterialCompositionProps {
    material: RawMaterial
}

export function PowderRawMaterialCompositionCard({ material }: PowderRawMaterialCompositionProps) {

    return (
        <div className=" border-primary-dark dark:border-primary-light bg-primary-light dark:bg-primary-dark p-3 space-y-2">
            <div className="flex items-center justify-between">
                <div className="text-sm font-semibold text-primary-dark dark:text-primary-light">{material.raw_mtrl}</div>
                <div className="text-xs text-primary-dark dark:text-primary-light">Lot: {material.lot}</div>
            </div>

            <div className="grid grid-cols-2 gap-2 text-xs">
                <div><span className="text-primary-dark dark:text-primary-light">C%</span> <span className="text-oi-button-blue dark:text-oi-powder-form-yellow">{formatNumber(material.cPercent ?? 0)}</span></div>
                <div><span className="text-primary-dark dark:text-primary-light">O%</span> <span className="text-oi-button-blue dark:text-oi-powder-form-yellow">{formatNumber(material.oPercent ?? 0)}</span></div>
                <div><span className="text-primary-dark dark:text-primary-light">Ratio</span> <span className="text-oi-button-blue dark:text-oi-powder-form-yellow">{formatNumber(material.ratioPercent ?? 0)}</span></div>
                <div>
                    <span className="text-primary-dark dark:text-primary-light">Weight (g)</span>{" "}
                    <button
                        type="button"
                        onClick={() => { }}
                        className="text-oi-button-blue dark:text-oi-powder-form-yellow hover:opacity-80"
                        title="Click to add Weight (g) to Allocate (g)"
                    >
                        {formatNumber(Number(material.weightG ?? 0))}
                    </button>
                </div>
            </div>

            <div className="grid grid-cols-[36px_1fr] gap-2 items-center">
                <button
                    type="button"
                    className={`h-[36px] flex items-center justify-center  ? "text-primary-dark dark:text-primary-light" : "text-gray-400 cursor-not-allowed"}`}
                    onClick={() => { }}

                    aria-label="Move from stock to allocated"
                >
                    <AddCircle24Filled />
                </button>
                <input
                    type="text"
                    inputMode="decimal"
                    className={`h-[36px] w-full px-2 text-center text-xs text-oi-button-blue dark:text-oi-powder-form-yellow border bg-primary-light dark:bg-primary-dark focus:outline-none`}
                    value={0}
                    onChange={(e) => { }}
                    placeholder={"0"}
                    title={`Available`}
                />
            </div>

            <div className="grid grid-cols-1 gap-2">
                <DatePicker
                    className="w-full"
                    onSelectDate={() => { }}
                    placeholder="YYYY / MM / DD"
                    style={{ height: "36px", borderRadius: "0px", backgroundColor: "transparent" }}
                />

                <select

                    className="h-[36px] w-[100px] min-w-0 max-w-[100px] border border-primary-dark dark:border-primary-light bg-primary-light dark:bg-primary-dark px-2 text-xs text-primary-dark dark:text-primary-light focus:outline-none"
                    style={{ minWidth: 0, width: "100px", maxWidth: "100px" }}
                >
                    <option value="allocated">Allocated</option>
                    <option value="stock">Stock</option>
                </select>
            </div>

            <div className="grid grid-cols-2 gap-2 text-xs">
                <div><span className="text-primary-dark dark:text-primary-light">Allocated (g)</span> <span className="text-oi-button-blue dark:text-oi-powder-form-yellow">-</span></div>
                <div><span className="text-primary-dark dark:text-primary-light">Stock (g)</span> <span className="text-oi-button-blue dark:text-oi-powder-form-yellow">{formatNumber((material.inStockGrams ?? 0) * 1000)}</span></div>
            </div>
        </div>
    );
}

export default function PowderRawMaterialCompositionTableRow({ material }: PowderRawMaterialCompositionProps) {
    const [selectedCompositionMaterial, setSelectedCompositionMaterial] = useState<RawMaterial | null>(null);

    const renderLotValue = () => {
        if (!hasChemicalComposition(material)) {
            return material.lot || "-";
        }

        return (
            <button
                type="button"
                className="cursor-pointer underline underline-offset-2 hover:opacity-80"
                onClick={() => setSelectedCompositionMaterial(material)}
                title="Show chemical composition"
            >
                {material.lot || "-"}
            </button>
        );
    };

    return (
        <>
            <tr className="h-[28px] bg-primary-light dark:bg-primary-dark">
                <td className="px-1 text-xs font-medium text-primary-dark dark:text-primary-light">{material.raw_mtrl}</td>
                <td className="px-1 text-xs font-medium text-primary-dark dark:text-primary-light">{renderLotValue()}</td>
                <td className="px-1 text-xs text-oi-button-blue dark:text-oi-powder-form-yellow">{formatNumber(material.cPercent ?? 0)}</td>
                <td className="px-1 text-xs text-oi-button-blue dark:text-oi-powder-form-yellow">{formatNumber(material.oPercent ?? 0)}</td>
                <td className="px-1 text-xs text-oi-button-blue dark:text-oi-powder-form-yellow">{formatNumber(material.ratioPercent ?? 0)}</td>
                <td className="px-1 text-xs text-oi-button-blue dark:text-oi-powder-form-yellow">
                    <button
                        type="button"

                        className="hover:opacity-80"
                        title="Click to add Weight (g) to Allocate (g)"
                    >
                        {formatNumber(Number(material.weightG ?? 0))}
                    </button>
                </td>
                {/* <td className=" text-xs text-oi-button-blue dark:text-oi-powder-form-yellow text-center">
                    <button
                        type="button"
                        className={`h-full flex items-center w-full justify-center border-primary-dark dark:border-primary-light `}

                        aria-label="Move from stock to allocated"
                    >
                        <AddCircle24Filled />
                    </button>
                </td>
                <td className="px-1">
                    <div className={`h-[36px] w-[54px] flex items-center border`}>
                        <input
                            type="text"
                            inputMode="decimal"
                            className="h-full w-full px-2 text-center text-xs text-oi-button-blue dark:text-oi-powder-form-yellow bg-primary-light dark:bg-primary-dark focus:outline-none"
                        />
                    </div>
                </td>
                <td className="px-1">
                    <DatePicker
                        className="w-full"

                        onSelectDate={(date) => {
                            const next = date ? date.toLocaleDateString("sv-SE") : "";

                        }}
                        placeholder="YYYY / MM / DD"
                        style={{
                            height: "36px",
                            borderRadius: "0px",
                            backgroundColor: "transparent"
                        }}
                    />
                </td>
                <td className="px-1 w-[100px]">
                    <select


                        className="h-[36px] w-[100px] min-w-0 max-w-[100px] border border-primary-dark dark:border-primary-light bg-primary-light dark:bg-primary-dark px-2 text-xs text-primary-dark dark:text-primary-light focus:outline-none"
                        style={{ minWidth: 0, width: "100px", maxWidth: "100px" }}
                    >
                        <option value="allocated">Allocated</option>
                        <option value="stock">Stock</option>
                    </select>
                </td>
                <td className="px-1 text-xs text-oi-button-blue dark:text-oi-powder-form-yellow">0</td> */}
                <td className="px-1 text-xs text-oi-button-blue dark:text-oi-powder-form-yellow">{formatNumber(Number(material.inStockGrams ?? 0) * 1000)}</td>
            </tr>
            <Dialog
                open={Boolean(selectedCompositionMaterial)}
                onOpenChange={(_, data) => {
                    if (!data.open) {
                        setSelectedCompositionMaterial(null);
                    }
                }}
            >
                <DialogSurface>
                    <DialogBody>
                        <DialogTitle>
                            Lot Details{selectedCompositionMaterial?.lot ? `: ${selectedCompositionMaterial.lot}` : ""}
                        </DialogTitle>
                        <DialogContent>
                            {selectedCompositionMaterial?.powderComposition ? (
                                <PowderPieChart data={selectedCompositionMaterial.powderComposition} />
                            ) : null}
                        </DialogContent>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        </>
    );
}
